module.exports = __webpack_public_path__ + "img/read_message.e28e4be0.svg";